<template>
    <div class="local-data">
        <div class="filter-criteria">
            <div class="filter-title">本地数据</div>
            <div class="filter-content">
                <a-row class="row-list">
                    <a-col :span="12">
                        <span class="row-title">领取时间：</span>
                        <a-range-picker v-model="payDate" class="date-range" @change="onChange" style="" format="YYYY-MM-DD HH:mm:ss" />
                    </a-col>
                    <a-col :span="12">
                        <span class="row-title">负责人：</span>
                        <a-select v-model="currentPerson" placeholder='请选择负责人' @change="changePerson" class="charge-person">
                            <a-select-option :value="item.value" v-for="(item,index) in selectList" :key='index'>
                                {{item.name}}
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>
                <a-row class="row-list">
                    <a-col :span="12">
                        <span class="row-title">搜索：</span>
                        <a-input v-model="contactWay" placeholder="输入企业/联系人名称/手机号" class="search-way"  @change="inputChange()" />
                    </a-col>
                    <a-col :span="12">
                        <span class="row-title">联系方式：</span>
                        <a-select v-model="contactInformationType" placeholder='请选择联系方式' @change="changeContactWay" class="charge-person">
                            <a-select-option value="QQ"  key='QQ'>
                                QQ
                            </a-select-option>
                            <a-select-option value="传真"  key='传真'>
                                传真
                            </a-select-option>
                            <a-select-option value="固话"  key='固话'>
                                固话
                            </a-select-option>
                            <a-select-option value="微信"  key='微信'>
                                微信
                            </a-select-option>
                            <a-select-option value="手机"  key='手机'>
                                手机
                            </a-select-option>
                            <a-select-option value="邮箱"  key='邮箱'>
                                邮箱
                            </a-select-option>
                            <a-select-option value="其他"  key='其他'>
                                其他
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>
                <a-row class="row-list">
                    <a-col :span="12">
                        <span class="row-title">是否推荐联系人：</span>
                        <a-select v-model="isRecommend" placeholder='是否推荐联系人' @change="changeRecomendPerson" class="charge-person">
                            <a-select-option value="是"  key='是'>
                                是
                            </a-select-option>
                            <a-select-option value="否"  key='否'>
                                否
                            </a-select-option>
                        </a-select>
                    </a-col>
                    <a-col :span="12">
                        <span @click="cleanUpCondition" class="clean-up">清空</span>
                    </a-col>
                </a-row>
            </div>
        </div>
        <div class="table-data">
            <div class="table-content">
                <div>
                    <a-radio-group name="radioGroup" :default-value="1" @change="changeWay">
                        <a-radio :value="1">
                        按企业
                        </a-radio>
                        <a-radio :value="2">
                        按联系人
                        </a-radio>
                    </a-radio-group>
                    <a-dropdown v-if="userRole!=3" :trigger="['click']" class="output-data">
                        <a-menu slot="overlay" @click="downloadOperate">
                            <a-menu-item key="1" class="more-operate-item more-operate-item1">
                                <div>导出选项</div>
                                <div>(选中{{selectedRowKeys.length}}条)</div>
                            </a-menu-item>
                            <a-menu-item key="2" class="more-operate-item">
                                <div>导出所有</div>
                                <div>(共{{total}}条)</div>
                            </a-menu-item>
                        </a-menu>
                        <a-button type="primary"> 导出 </a-button>
                    </a-dropdown>
                </div>
                <div class="table-data">
                    <a-table
                        v-if="selectedWay==1"
                        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                        :data-source="tableData"
                        :pagination='false'
                        :scroll="{ x: 'max-content' }"
                        :rowKey="record => record.id"
                    >
                        <a-table-column key="name" title="企业名称" data-index="name">
                            <template slot-scope="text, record">
                                <div style="cursor:pointer;color:rgb(24, 144, 255)" @click="viewDetail(record.enterpriseUuid)">{{ record.name }}</div>
                            </template>
                        </a-table-column>
                        <a-table-column key="businessStatus" title="经营状态" data-index="businessStatus" />
                        <a-table-column key="businessCorporation" title="企业法人" data-index="businessCorporation" />
                        <a-table-column key="registeredCapital" title="注册资本" data-index="registeredCapital" />
                        <a-table-column key="establishDate" title="建立时间" data-index="establishDate" />
                        <a-table-column key="type" title="企业类型" data-index="type" />
                        <a-table-column key="industry" title="所属行业" data-index="industry" />
                        <a-table-column key="scale" title="企业规模" data-index="scale" />
                    </a-table>
                    <a-table
                        v-if="selectedWay==2"
                        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                        :data-source="tableData"
                        :pagination='false'
                        :scroll="{ x: 'max-content' }"
                        :rowKey="record => record.id"
                    >
                        <a-table-column key="enterpriseName" title="企业名称" data-index="enterpriseName">
                            <template slot-scope="text, record">
                                <div style="cursor:pointer;color:rgb(24, 144, 255)" @click="viewDetail(record.enterpriseUuid)">{{ record.enterpriseName }}</div>
                            </template>
                        </a-table-column>
                        <a-table-column key="name" title="联系人名称" data-index="name" />
                        <a-table-column key="contactInformationType" title="联系方式类型" data-index="contactInformationType" />
                        <a-table-column key="contactInformation" title="联系方式" data-index="contactInformation" />
                        <a-table-column key="isRecommend" title="是否推荐" data-index="isRecommend" />
                        <a-table-column key="receiveUser" title="领取人" data-index="receiveUser" />
                        <a-table-column key="receiveTime" title="领取时间" data-index="receiveTime" />
                    </a-table>
                    <div class="pagination-table">
                        <div style="float:left;color:rgba(80, 80, 80, 1);font-size:14px">总计：{{total}}条</div>
                        <a-pagination
                        style="float:right"
                            show-size-changer
                            :total="total"
                            :show-total="total => `共 ${total} 条`"
                            v-model="currentPage"
                            @change="pageChange"
                            @showSizeChange="onShowSizeChange"
                        />
                    </div>
                </div>
            </div>
        </div>
        <a-drawer
            title=''
            placement="right"
            :closable="true"
            :visible="drawerVisibleSence"
            :destroyOnClose='true'
            :maskClosable='true'
            @close="onCloseDrawerSence"
            :width='800'
            :mask='true'
            :headerStyle="{ border: 'none', height: '56px', position: 'absolute', width: '100%', left: '0', top: '0', zIndex: '0'}"
            :bodyStyle="{ background: 'rgba(240, 242, 243, 1)', height: '100%', position: 'absolute', width: '100%', left: '0', top: '0', zIndex: '10', padding: '0 0 0' }"
        >
            <div class="drawer-detail">
                <iframe :src="detailUrl" class="iframe1" id="iframe1"></iframe>
            </div>
        </a-drawer>
    </div>
</template>

<script>
    import moment from 'moment';
    export default {
        name: 'MonthBill',
        components: {  },
        data() {
            return {
                payDate: [null, null],
                contactWay: '',
                selectedRowKeys: [],
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0,
                loading: false,
                drawerVisibleSence: false,
                detailUrl: '',
                canRun: true,
                timer: null,
                userRole: null,
                selectList: [],
                currentPerson: undefined,
                selectedWay: 1,
                contactInformationType: undefined,
                isRecommend: undefined,
            }   
        },
        methods: {
            moment,
            onChange(date, dateString) {
                console.log(date, dateString);
                this.payDate = dateString
                this.currentPage = 1
                this.pageSize = 10
                this.selectedRowKeys = []
                this.queryBasicData()
            },
            cleanUpCondition() {
                this.payDate = [null, null]
                this.contactWay = ''
                this.contactInformationType = undefined
                this.currentPerson = undefined
                this.currentPage = 1
                this.pageSize = 10
                this.selectedRowKeys = []
                this.isRecommend = undefined
                this.queryBasicData()
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            pageChange(current, pageSize) {
                this.currentPage = current
                this.pageSize = pageSize
                this.queryBasicData()
            },
            onShowSizeChange(current, pageSize) {
                this.currentPage = current
                this.pageSize = pageSize
                this.queryBasicData()
            },
            queryBasicData() {
                let url = ''
                if(this.selectedWay == 1){
                    url = '/api/receiveData/enterprise/list'
                }else{
                    url = '/api/receiveData/contact/list'
                }
                this.axios(
                    {
                        method: 'get',
                        url: url, 
                        params: {
                            current: this.currentPage,
                            size: this.pageSize,
                            param: this.contactWay,
                            owner: this.currentPerson,
                            receiveTimeStart: this.payDate[0],
                            receiveTimeEnd: this.payDate[1],
                            contactInformationType: this.contactInformationType,
                            isRecommend: this.isRecommend
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.tableData = response.data.data.records
                        this.total = response.data.data.total
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            onCloseDrawerSence() {
                this.drawerVisibleSence = false
            },
            downloadOperate(e) {
                if(e.key == '1'){
                    if(this.selectedRowKeys.length==0){
                        this.$message.error('请先选择')
                    }else{
                        this.downloadData(1)
                    }
                }else if(e.key == '2'){
                    if(this.total == 0){
                        this.$message.error('暂无可导出内容')
                    }else{
                        this.downloadData(2)
                    }
                }
            },
            downloadData(params) {
                this.axios.post('/api/export', {
                    count: params==1?this.selectedRowKeys.length:this.total,
                    recordDataIdList: params==1?this.selectedRowKeys:[],
                    type: this.selectedWay,
                    param: this.contactWay,
                    owner: this.currentPerson,
                    receiveTimeStart: this.payDate[0],
                    receiveTimeEnd: this.payDate[1],
                    contactInformationType: this.contactInformationType,
                    isRecommend: this.isRecommend
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('导出成功')
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            viewDetail(id) {
                this.drawerVisibleSence = true
                this.axios(
                    {
                        method:'get',
                        url:'/api/receiveData/detailUrl', 
                        params: {
                            id: id,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.detailUrl = response.data.data.detailUrl
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            carryFun() {
                this.currentPage = 1
                this.pageSize = 10
                this.selectedRowKeys = []
                this.queryBasicData()
            },
            inputChange() {
                if(this.timer!=null){
                    clearTimeout(this.timer)
                }
                this.timer = setTimeout(()=>{
                    this.carryFun()
                },1000)
            },
            changePerson(value) {
                this.currentPerson = value
                this.currentPage = 1
                this.pageSize = 10
                this.selectedRowKeys = []
                this.queryBasicData()
            },
            changeContactWay(value) {
                this.contactInformationType = value
                this.currentPage = 1
                this.pageSize = 10
                this.selectedRowKeys = []
                this.queryBasicData()
            },
            changeRecomendPerson(value) {
                this.isRecommend = value
                this.currentPage = 1
                this.pageSize = 10
                this.selectedRowKeys = []
                this.queryBasicData()
            },
            querySelectList() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/user/selectList', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.selectList = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            changeWay(e) {
                this.selectedWay = e.target.value
                this.currentPage = 1
                this.pageSize = 10
                this.selectedRowKeys = []
                this.queryBasicData()
            },
        },
        mounted: function() {
            this.queryBasicData()
            this.querySelectList()
            this.userRole = sessionStorage.getItem('userRole')
        }
    }

</script>

<style scoped lang="less">
    .local-data{
        height: 100%;
        display: flex;
        flex-direction: column;
        .filter-criteria{
            height: 200px;
            background: #fff;
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
            margin-top: 1px;
            padding: 15px 24px;
            .filter-title{
                color: rgba(0, 0, 0, 0.7);
                font-size: 14px;
            }
            .filter-content{
                margin-top: 24px;
                .row-list{
                    margin-bottom: 16px;
                    .row-title{
                        display: inline-block;
                        width: 115px;
                    }
                    .charge-person{
                        width: 240px;
                    }
                    .date-range{
                        width: 325px;
                    }
                    .search-way{
                        width: 325px;
                    }
                }
                .clean-up{
                    float: right;
                    color: rgba(24, 144, 255, 1);
                    font-size: 14px;
                    cursor: pointer;
                }
            }
        }
        .table-data{
            flex: 1;
            padding: 24px;
            .table-content{
                width: 100%;
                height: 100%;
                background: #fff;
                padding: 24px;
                .table-data{
                    margin-top: 24px;
                }
                .pagination-table{
                    padding-top: 24px;
                    width: 100%;
                }
                .output-data{
                    float: right;
                }
            }
        }
    }
    .drawer-detail{
        width: 100%;
        height: 100%;
        .iframe1{
            width: 100%;
            height: 100%;
            border: medium none;
        }
    }
</style>